/**
 * Project : workspace
 * File    : StoreCategory.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.customer.store.component

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.commerce.feature.inventory.productCategory.handler.ProductCategoryHandler
import com.parmartechnologies.core.feature.productCategory.model.ProductCategory
import component.product.ProductCategoryCard
import navigation.AppNavigator
import navigation.commerce.route.home.CommerceHomeNavRoute

@Composable
/**
 * Executes the store category operation.
 *
 * @receiver TODO
 * @param categories The categories.
 * @return Unit – no return value.
 */
fun StoreCategory(categories: State<List<ProductCategory>>) {
    val navParam = AppNavigator.shared().getNavigationParam()
    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight().clickable {

    }) {
        if(categories.value.isNotEmpty()){
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(start = 6.dp, top = 15.dp, end = 6.dp)
            ) {
                Text(
                    "Categories",
                    fontWeight = FontWeight.Bold,
                    fontSize = 20.sp,
                    modifier = Modifier
                        .weight(0.5f)
                )
                Text(
                    "View All",
                    fontSize = 14.sp,
                    color = Color.Blue
                )
            }
        }
        LazyRow(modifier = Modifier.padding(start = 8.dp, end = 8.dp)) {
            items(count = categories.value.count()) { index ->
                ProductCategoryCard(category = categories.value[index], onClick = {cat->
                    ProductCategoryHandler.shared().repository.selectedCategoryForNavigation = cat
                    navParam.productCategory = cat
                    AppNavigator.shared().navigate(CommerceHomeNavRoute.CATEGORY,navParam)
                })
            }
        }
    }
}